import API from './API.js'

export default class CommentGeneral extends API {
  constructor() {
    super('comment-general')
  }
 
 
}